// This file was automatically generated from app.shared.dialog.linkOrder.html.
// Please don't edit this file by hand.

goog.provide('el8.template.app.shared.dialog.linkOrder');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.dialog.linkOrder.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DialogContainer"><form><div class="field-wrapper"><div class="el8FieldSection ebs-form-group"><label class="el8FieldMedium ebs-control-label ebs-col-sm-3"><span class="el8FieldSection">Order:</span></label><div class="el8Wrap el8FieldMediumLabelPadding ebs-col-sm-9"><select class="order-to-link-trigger" name="orderToLink" class="w100"></select></div></div></div></form></div>');
  if (!opt_sb) return output.toString();
};
